import React from 'react';

import Button from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

type Props = {
    busy: boolean,
    editDisabled: boolean,
    anyChanged: boolean,
    isLoadingAny: boolean,
    saveAction?: React.ReactNode,
    onSave: () => void,
    onDiscard: () => void,
};

export const ConnectorLimitsHeader = ({
    busy,
    editDisabled,
    anyChanged,
    isLoadingAny,
    saveAction,
    onSave,
    onDiscard,
}: Props) => (
    <Item grow={1}>
        <Group justify="space-between">
            <Typography
                fontWeight="semi-bold"
                variant="heading-level-3">
                Connector Limits
            </Typography>
            {!editDisabled && (
                <Group>
                    <Button
                        variant="Type.SECONDARY"
                        disabled={
                            !anyChanged || isLoadingAny
                        }
                        onClick={onDiscard}>
                        Discard Changes
                    </Button>
                    {saveAction ?? (
                        <Button
                            busy={busy}
                            variant="Type.PRIMARY"
                            disabled={
                                !anyChanged || isLoadingAny
                            }
                            onClick={onSave}>
                            Save Changes
                        </Button>
                    )}
                </Group>
            )}
        </Group>
    </Item>
);
